import * as bootstrap from 'bootstrap';
import $ from "jquery";
import api from "./ajax";

const respondToJob = () => {
    const selectRegistrationModalEl = document.getElementById('selectRegistrationModal');

    $('#acceptJob').on('click', (e) => {
        e.preventDefault();

        const {currentTarget} = e;
        const btnEl = $(currentTarget);
        const registeredVehicleInput = $('#registeredVehicle');
        const requiresRegistrationSelect = registeredVehicleInput.length;
        const selectRegistrationModal = new bootstrap.Modal(selectRegistrationModalEl);
        const selectRegistrationRadioBtns = document.querySelectorAll('input[name="registration_number"]');
        const confirmRegistrationBtn = document.getElementById('confirmRegistrationBtn');

        if (btnEl.hasClass('accept')) {
            if (btnEl.hasClass('disabled')) {
                $('label[for=agreeToTerms]').addClass('invalid');
                $('#agreeToTerms').addClass('invalid');
            }

            if ($('#agreeToTerms').is(":checked")) {
                $('#jobResponse').val("CON");

                if (!requiresRegistrationSelect) {
                    $('#acceptJobForm').submit();
                    return;
                }

                // Show the select registration modal
                selectRegistrationModal.show();

                // $('#acceptJobForm').submit();
            }
        }

        if (selectRegistrationRadioBtns) {
            selectRegistrationRadioBtns.forEach(function (radio) {
                radio.addEventListener('change', function () {
                    if (radio.checked) {
                        confirmRegistrationBtn.disabled = false;
                    }
                });
            });
        }

        if (confirmRegistrationBtn) {
            confirmRegistrationBtn.addEventListener('click', function () {
                e.preventDefault();

                // Get the vale of selected radio button
                const selectedRegistrationNumber = document.querySelector(
                    'input[name="registration_number"]:checked').value;

                // Set the value of the selected registration number to the hidden input field
                registeredVehicleInput.val(selectedRegistrationNumber);

                $('#acceptJobForm').submit();
            });
        }

    });

    $('#agreeToTerms').on('click', (e) => {
        const {currentTarget} = e;
        const checkBoxEl = $(currentTarget);

        if (checkBoxEl.is(":checked")) {
            $('label[for=agreeToTerms]').removeClass('invalid');
            $('#agreeToTerms').removeClass('invalid');
            $('.btn.accept').removeClass('disabled');
        } else {
            $('.btn.accept').addClass('disabled');
        }
    });

    if (selectRegistrationModalEl) {
        selectRegistrationModalEl.addEventListener('show.bs.modal', (e) => {
            const {relatedTarget} = e;
            const btnEl = $(relatedTarget);
            const isChange = btnEl.data('action') === 'change';
            const id = btnEl.data('id');
            const confirmBtn = $('#confirmRegistrationBtn');

            if (isChange) {
                // Enable the confirm button
                confirmBtn.prop('disabled', false);

                // Add an on click event listener to the confirm button
                confirmBtn.on('click', async (e) => {

                    // Get the vale of selected radio button
                    const selectedRegistrationNumber = document.querySelector(
                        'input[name="registration_number"]:checked').value;

                    const response = await api.updateRego(id, selectedRegistrationNumber, 'job');

                    const {body, error} = response;

                    if (error) {
                        return;
                    }

                    const rego = body.registered_vehicle;

                    $('#rego').text(rego);

                });
            }
        });
    }
}

export default respondToJob();